export default function NavbarHeader() {
  return (
    <div className="navbar-header">
      <div className="container">

        <div style={{ flexGrow: 1, width: '100%' }}></div>
        <a>Sign In</a>
        <a>Sign Up</a>

      </div>
    </div>
  )
}